/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Workus API
 * FastAPI application with Clerk authentication
 * OpenAPI spec version: 0.1.2
 */

/**
 * Order by direction for sorting - HTTP DTO.
 */
export type OrderBy = (typeof OrderBy)[keyof typeof OrderBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderBy = {
  asc: "asc",
  desc: "desc",
} as const;
